export const isAuthenticated = ()=>{
    const token = localStorage.getItem('token');
    if(token && token !== '') return true;
    return false
}

export const logout=()=>{
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    window.location.replace('/')
}